import { render, staticRenderFns } from "./FormColorPicker.vue?vue&type=template&id=2847ba62"
import script from "./FormColorPicker.vue?vue&type=script&lang=js"
export * from "./FormColorPicker.vue?vue&type=script&lang=js"
import style0 from "./FormColorPicker.vue?vue&type=style&index=0&id=2847ba62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports